type NavItemLike = { adminOnly?: boolean; preview?: boolean };

type NavVisibility = {
  isAdmin: boolean;
  /** Preview features (e.g. Para setup) are shown outside the production build only. */
  previewEnabled: boolean;
};

export const filterNavItems = <T extends NavItemLike>(
  items: readonly T[],
  { isAdmin, previewEnabled }: NavVisibility,
): T[] =>
  items.filter(
    (item) => (item.adminOnly ? isAdmin : true) && (item.preview ? previewEnabled : true),
  );
